module.exports = __webpack_public_path__ + "static/media/backup_05.525425a1.svg";